<template>
    <div v-show="visible"
         class="card card-body templateFieldsPopup"
         style="user-select:none;padding:10px;">

        <div style="position:absolute;top:5px;right:8px;color:#ddd;cursor:pointer;z-index:1"
             @click="visible = false">
            <i class="fa-solid fa-times"></i>
        </div>

        <div class="templateFieldsPopupTables">

            <table class="table"
                   v-for="section in sections"
                   :key="section.title"
                   style="width:270px;margin-bottom:0">
                <tbody>
                    <tr>
                        <td colspan="2"
                            style="text-align: center;font-weight:bold;border-bottom:none">
                            {{ section.title }}
                        </td>
                    </tr>
                    <tr v-for="field in section.fields"
                        :key="field">
                        <td style="width:190px;">
                            {{ field }}
                        </td>
                        <td>
                            <button class="btn btn-xs btn-primary"
                                    @click="$emit('insert', field)">
                                <i class="fa-solid fa-plus"
                                   style="position:relative;top:1px"></i>
                                הוסף
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>

    </div>
</template>
<script>

//a floating card with {{parameter}} tables, one table per section (e.g. פגישה / אירוע).
//parent positions it (position:absolute + top/right via style attribute),
//toggles it via ref, and inserts the emitted field wherever it wants
export default {
    name: 'TemplateFieldsPopup',

    props: ['sections'],

    data() {
        return {
            visible: false
        }
    },

    methods: {

        show() {
            this.visible = true;
        },

        hide() {
            this.visible = false;
        },

        toggle() {
            this.visible = !this.visible;
        }
    }
}
</script>
<style>
.templateFieldsPopupTables {
    max-height: 320px;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>
